(function () {
  'use strict';

  // pdpProductDataTabbar is a global injected by the section liquid
  // (var pdpProductDataTabbar = {{ product | json }};). We read it via window
  // to stay compatible while remaining inside the IIFE.

  let lastScrollTop = window.pageYOffset || document.documentElement.scrollTop;

  function scrollToForm(elementId) {
    const element = document.getElementById(elementId);
    if (!element) return;
    element.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  // Nimmt mehrere IDs entgegen und scrollt zur ersten, die im DOM existiert
  // (Section-ID der Metaobjekt-Section oder Legacy-ID aus dem Snippet-Markup).
  function scrollToTop(...elementIds) {
    let element = null;
    for (const id of elementIds) {
      element = document.getElementById(id);
      if (element) break;
    }
    if (!element) return;
    const offsetTop = element.getBoundingClientRect().top + window.pageYOffset - 184;
    window.scrollTo({
      top: offsetTop,
      behavior: 'smooth',
    });
  }

  function stickyNavbar() {
    if (window.innerWidth > 1023) {
      const pdpNavbar = document.querySelector('.Pdp-Stickytabbar-Container');
      const pdpNavbarbutton = document.querySelector('.Pdp-Stickytabbar-Scrollable-Button');
      if (!pdpNavbar || !pdpNavbarbutton) return;

      const pdpNavbarBreakpointFormButton = document.querySelector('.Pdp-Argumente-Container');
      const pdpTnForm = document.getElementById('TN-Form-Dialog');
      const pdpNavbarBreakpointSticky = document.querySelector('.Pdp-Header-Container');

      // Im PDP-Hero liegt die TN-Box IM FLOW (position: static, s. pdp-hero.css) und
      // scrollt mit — sie kann den CTA also nicht bis zur Argumente-Section halten.
      // Der Leisten-Button uebernimmt deshalb, sobald die Tabbar sichtbar wird.
      // Die alte fixed Box (Legacy-Templates) behaelt ihren bisherigen Uebergabepunkt.
      const heroInFlowTnForm = document.querySelector('.pdp-hero #TN-Form-Dialog');

      if (!pdpNavbarBreakpointSticky) return;
      if (!heroInFlowTnForm && (!pdpNavbarBreakpointFormButton || !pdpTnForm)) return;

      const sticky = pdpNavbar.offsetTop;
      const unSticky = pdpNavbarBreakpointSticky.offsetHeight;
      const pdpNavbarFormBreak = pdpNavbarBreakpointFormButton
        ? pdpNavbarBreakpointFormButton.offsetTop - pdpNavbarBreakpointFormButton.offsetHeight * 1.4
        : null;

      if (window.pageYOffset >= sticky) {
        if (window.pageYOffset > lastScrollTop) {
          pdpNavbar.classList.add('sticky');
          pdpNavbar.classList.remove('stickyScrollUp');
        } else if (window.pageYOffset < lastScrollTop) {
          pdpNavbar.classList.add('stickyScrollUp');
          pdpNavbar.classList.remove('sticky');
        }
      } else {
        pdpNavbar.classList.remove('sticky');
        pdpNavbar.classList.remove('stickyScrollUp');
      }

      if (window.pageYOffset <= unSticky) {
        pdpNavbar.classList.remove('sticky');
        pdpNavbar.classList.remove('stickyScrollUp');
      }

      if (heroInFlowTnForm) {
        // Button an die Sichtbarkeit der Tabbar koppeln. Der Klassen-Zustand wird oben
        // gesetzt und traegt die Hysterese der sticky/stickyScrollUp-Logik — nachgerechnete
        // Schwellenwerte wuerden an den Raendern flackern (pdpNavbar.offsetTop wird 0,
        // sobald die Leiste fixed ist).
        // Die In-Flow-Box wird NICHT per display umgeschaltet: das wuerde die rechte
        // Hero-Spalte kollabieren lassen und einen Layout-Sprung verursachen.
        const tabbarVisible =
          pdpNavbar.classList.contains('sticky') || pdpNavbar.classList.contains('stickyScrollUp');
        pdpNavbarbutton.style.display = tabbarVisible ? 'flex' : 'none';
      } else if (window.pageYOffset >= pdpNavbarFormBreak) {
        pdpNavbarbutton.style.display = 'flex';
        pdpTnForm.style.display = 'none';
      } else {
        pdpNavbarbutton.style.display = 'none';
        pdpTnForm.style.display = 'flex';
      }

      lastScrollTop = window.pageYOffset;
    } else {
      const pdpFloatingBar = document.getElementById('TN-Floatingbar');
      if (!pdpFloatingBar) return;

      const pdpfloatBarBreakpointSticky = document.querySelector('.Pdp-Header-Container');
      if (!pdpfloatBarBreakpointSticky) return;

      const unSticky = pdpfloatBarBreakpointSticky.offsetHeight;
      pdpFloatingBar.style.display = window.pageYOffset >= unSticky ? 'flex' : 'none';
    }
  }

  const sections = [
    { id: 'Pdp-Modules-Section', tabId: 'Pdp-Tab-Module' },
    { id: 'Pdp-Ratings-Section', tabId: 'Pdp-Tab-Bewertungen' },
    { id: 'Pdp-Beratung-Section', tabId: 'Pdp-Tab-Beratung' },
    { id: 'Pdp-About-Section', tabId: 'Pdp-Tab-About' },
    { id: 'Pdp-Banner-Section', tabId: 'Pdp-Tab-Banner' },
    { id: 'Pdp-FAQ-Section', tabId: 'Pdp-Tab-FAQ' },
    { id: 'dynamic-accordion-section', tabId: 'Pdp-Tab-Inhalte' },
    { id: 'pdp-qcg-vorteile', tabId: 'Pdp-Tab-Vorteile' },
  ];

  // Metaobjekt-Section: bei QCG gehört sie zum About-Tab, sonst zum Infos-Tab.
  const pdpProductType = (window.pdpProductDataTabbar || {}).type;
  sections.push({
    id: 'Pdp-Additional-Information-Section',
    tabId: pdpProductType === 'QCG' ? 'Pdp-Tab-About' : 'Pdp-Tab-Infos',
  });

  function getClosestSection() {
    let closestSection = null;
    let closestDistance = Infinity;

    sections.forEach(({ id }) => {
      const section = document.getElementById(id);
      if (section) {
        const rect = section.getBoundingClientRect();
        const distance = Math.abs(rect.top);
        if (distance < closestDistance) {
          closestSection = id;
          closestDistance = distance;
        }
      }
    });

    return closestSection;
  }

  function setActiveTab() {
    const closestSectionId = getClosestSection();
    sections.forEach(({ id, tabId }) => {
      // Mehrere Einträge können auf dieselbe tabId zeigen (Legacy-IDs aus dem
      // Snippet-Markup und Metaobjekt-Section-IDs). Einträge ohne Element auf der
      // aktuellen Seite überspringen, sonst löscht ein späterer Eintrag das
      // Highlight, das der existierende gerade gesetzt hat.
      if (!document.getElementById(id)) return;
      const tab = document.getElementById(tabId);
      if (!tab) return;
      if (id === closestSectionId) {
        tab.classList.add('Pdp-Stickytabbar-Tab-Current');
      } else {
        tab.classList.remove('Pdp-Stickytabbar-Tab-Current');
      }
    });
  }

  // Init
  setActiveTab();

  // Listeners — additive (no window.onscroll overwrite hazard).
  window.addEventListener('scroll', stickyNavbar);
  window.addEventListener('scroll', setActiveTab);
  window.addEventListener('resize', setActiveTab);

  // Globals für die Inline-onclick-Handler in pdp-stickytabbar.liquid und weiteren PDP-Sections.
  window.scrollToForm = scrollToForm;
  window.scrollToTop = scrollToTop;
})();
